import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ParEmployeeService } from '../../services/par_employees/par_employees.service';

@Component({
  selector: 'app-parsummary',
  templateUrl: './parsummary.component.html',
  styleUrls: ['./parsummary.component.css']
})
export class ParsummaryComponent implements OnInit {
  DocListErrMsg;
  currentDate = new Date();
  DocListErr: boolean = false;
  data: any = {
    name: '',
    typeofBusinessStructure: '',
    dateofIncorporation: '',
    stateofIncorporation: '',
    address: '',
    phone: '',
    description: '',
    auditedFinancials: '',
    dunnBradstreet: '',
    taxIdNumber: '',
    website: '',
    publicorPrivate: '',
    complianceContact: '',
    numberofEmployees: '',
  };
  submitSuccess;
  message;
  errorOccured: boolean = false;
  public showFlag: boolean = false;
  public submitFormData: any;
  getAllPARSummaryData: any[] = [];
PARSummaryId: any;
  parSummaryDetailsToInsert: any;
  constructor(private parEmployeeService: ParEmployeeService) { }

  ngOnInit() {
    this.parEmployeeService.getParSummary().subscribe(res => {
      this.getAllPARSummaryData = res.Summary[0];
     this.PARSummaryId = res.Summary[0]._id;
      this.PARSummaryEdited(this.getAllPARSummaryData);
    }, err => {
      this.DocListErrMsg = "PAR Employee Updation" + err;
      this.DocListErr = true;
    });
  }

  PARSummaryEdited(getAllPARSummaryData) {
    this.data.name = getAllPARSummaryData.Name;
    this.data.typeofBusinessStructure = getAllPARSummaryData.Type;
    this.data.dateofIncorporation = getAllPARSummaryData.DateIncorporated;
    this.data.stateofIncorporation = getAllPARSummaryData.StateIncorporated;
    this.data.address = getAllPARSummaryData.Address;
    this.data.phone = getAllPARSummaryData.Phone;
    this.data.description = getAllPARSummaryData.Description;
    this.data.auditedFinancials = getAllPARSummaryData.AuditFinancials;
    this.data.dunnBradstreet = getAllPARSummaryData.DunnAndBradStreet;
    this.data.taxIdNumber = getAllPARSummaryData.TaxId;
    this.data.website = getAllPARSummaryData.Website;
    this.data.publicorPrivate = getAllPARSummaryData.PublicOrPrivate;
    this.data.complianceContact = getAllPARSummaryData.ComplianceContract;
    this.data.numberofEmployees = getAllPARSummaryData.NumberOfEmployees;
  }
  onFormSubmit(form: NgForm) {
    this.parSummaryDetailsToInsert = form.value;
    this.submitFormData = {
      "summary_id": this.PARSummaryId,
      "name": this.parSummaryDetailsToInsert.name,
      "type": this.parSummaryDetailsToInsert.typeofBusinessStructure,
      "date_incorporated": this.parSummaryDetailsToInsert.dateofIncorporation,
      "state_incorporated": this.parSummaryDetailsToInsert.stateofIncorporation,
      "address": this.parSummaryDetailsToInsert.address,
      "phone": this.parSummaryDetailsToInsert.phone,
      "description": this.parSummaryDetailsToInsert.description,
      "audit_financials": this.parSummaryDetailsToInsert.auditedFinancials,
      "dunn_and_bradstreet": this.parSummaryDetailsToInsert.dunnBradstreet,
      "taxid": this.parSummaryDetailsToInsert.taxIdNumber,
      "website": this.parSummaryDetailsToInsert.website,
      "public_or_private": this.parSummaryDetailsToInsert.publicorPrivate,
      "compliance_contract": this.parSummaryDetailsToInsert.complianceContact,
      "no_of_employees": this.parSummaryDetailsToInsert.numberofEmployees
    };
    this.parEmployeeService.parSummaryDataEdited(this.submitFormData).subscribe(res => {
      if (res.Info === 'PAR Summary Updated Succesfully') {
        this.submitSuccess = true;
         this.message = 'PAR Summary Updated Successfully';
      }
    }, err => {
      this.DocListErrMsg = 'PAR Summary Updation' + err;
      this.DocListErr = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/parsummary/parsummary.component.ts